import React, { useEffect, useState } from "react"
import MetaTags from 'react-meta-tags';
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  
  Input,
  Button,
  Label,
} from "reactstrap"
import excelLogo from "../../assets/images/excel.png";
import { connect, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import Loader from "../../components/Common/Loader"
import Pagination from "../../components/Common/Pagination_ansync"
import Select from "react-select";
import { Link, useParams, } from "react-router-dom/cjs/react-router-dom.min";
import { getAgent, getCampaignFullList, getContactsRead, getGestionPorContacto, getGestionesContactoFilterAsync } from "../../helpers/backend";
import ModalManagementDetails from "../Whatsapp/components/ModalManagementDetails";
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/themes/material_green.css';
import 'flatpickr/dist/l10n/es.js'; // Importa el idioma español
import axios from 'axios'; 
import ButtonVolver from "../../components/ButtonVolver";
import Table from "../../components/Common/Table";

const GestionContacto = (props) => {
  const id = useParams().id
  const URL = process.env.REACT_APP_API_URL;
  const user = JSON.parse(localStorage.getItem("user"))
  const groups = String(user.groups);
  const [detallesModal, setDetallesModal] = useState(false);
  const [GestionDetallada, setGestionDetallada] = useState(false);
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [estado, setEstado] = useState('');
  const [agente, setAgente] = useState('');
  const [campana, setCampana] = useState('');
  const [selectedAgents, setSelectedAgents] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState([]);
  const [selectedEstado, setSelectedEstado] = useState([]);
  const [selectedType, setSelectedType] = useState([]);
  const [isLead, setIsLead] = useState(false);
  const [type, setType] = useState('');
  const [loading, setLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [params, setParams] = useState({
    count: 0,
    next: null,
    previous: null,
    results: [],
  });

  const handleSelectChange = (selectedOptions) => {
    const selectedContactData = selectedOptions ? selectedOptions.map(option => option.value).join(',') : '';
    setSelectedAgents(selectedOptions || []);
    setAgente(selectedContactData);
  };
  const handleSelectCampaignChange = (selectedOptions) => {
    setSelectedCampaign(selectedOptions || []);
    setCampana(selectedOptions.value);
  };
  const handleSelectEstadoChange = (selectedOptions) => {
    setSelectedEstado(selectedOptions || []);
    setEstado(selectedOptions.value); // Asumo que setAgente está definido en otro lugar y actualiza el estado correspondiente
  };
  const handleSelectTypeChange = (selectedOptions) => {
    setSelectedType(selectedOptions || []);
    setType(selectedOptions.value); // Asumo que setAgente está definido en otro lugar y actualiza el estado correspondiente
  };
  const [contact, setContact] = useState({})
  const getContactData = async () => {
    const response = await getContactsRead(id);
    const data = response.data;
    setContact(data);
  };
  const [agent, setAgent] = useState({});
  const getAgentData = async () => {
    const response = await getAgent();
    const data = response.data;
    setAgent(data)
  }
  const [campaignData, setCampaignData] = useState({});
  const getCampaignData = async () => {
    const response = await getCampaignFullList();
    const data = response.data;
    setCampaignData(data);
  };

  const theme = useSelector(s => s.theme.theme) || "light";

  const getGestionesData = async () => {
    const response = await getGestionPorContacto(id);
    setLoading(true);
    setParams({
      count: response.data.count,
      next: response.data.next,
      previous: response.data.previous,
      results: response.data.results,
    });
    setLoading(false);
  };

  const filterDate = async () => {
    setLoading(true);
    const response = await getGestionesContactoFilterAsync(`?contact=${id}&fecha_inicio=${fechaInicio}&fecha_fin=${fechaFin}&estado=${estado}&agents=${agente}&campaign=${campana}&type=${type}&is_leads=${isLead} `);
    setParams({
      count: response.data.count,
      next: response.data.next,
      previous: response.data.previous,
      results: response.data.results,
    });
    setLoading(false);
  };

  const resetSearch = () => {
    setFechaFin("");
    setFechaInicio("");
    setSelectedDate("");
    setEstado('');
    setAgente('');
    setSelectedAgents("");
    setSelectedCampaign("");
    setSelectedEstado("");
    setSelectedType("")
    setIsLead(false)
    setType("")
    getGestionesData()
  };

  useEffect(() => {
    getContactData()
    getGestionesData()
    getAgentData()
    getCampaignData()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const exportExcel = async () => {
    try {
      const url = `${URL}/contact/gestionContacto/exportar-excel/?contact=${id}&fecha_inicio=${fechaInicio}&fecha_fin=${fechaFin}&estado=${estado}&agents=${agente}&campaign=${campana}&type=${type}&is_leads=${isLead}`;
      const response = await axios.get(url, { responseType: 'blob' });
      if (response && response.data) {
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const urlBlob = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = urlBlob;
        link.setAttribute('download', 'Gestiones.xlsx'); // Nombre del archivo
        document.body.appendChild(link);
        link.click();
  
        // Limpiar el URL del blob
        window.URL.revokeObjectURL(urlBlob);
        document.body.removeChild(link);
      } else {
        console.error('No se recibieron datos para exportar.');
      }
    } catch (error) {
      console.error('Error al exportar el archivo:', error);
    }
  };
  const handleDetallesModal = () => {
    setDetallesModal(false);
  };
  const getFilterData = async (url) => {
    setLoading(true);
    const response = await getGestionesContactoFilterAsync(url);
    setParams({
      count: response.data.count,
      next: response.data.next,
      previous: response.data.previous,
      results: response.data.results,
    });
    setLoading(false);
  };
  const handleDateChange = (selectedDates) => {
    if (selectedDates.length === 2) {
      const [start, end] = selectedDates;
      setFechaInicio(start.toISOString().split('T')[0]); // Formato YYYY-MM-DD
      setFechaFin(end.toISOString().split('T')[0]); // Formato YYYY-MM-DD
      setSelectedDate(selectedDates)
    }
  };

  const columns = [
    { key: "indice",           label: "#",                   filterable: false },
    { key: "created_date",     label: "Fecha",               filterable: false },
    { key: "campaign",         label: "Campaña",             filterable: true  },
    { key: "type",             label: "Teléfono",            filterable: true  },
    { key: "conversation",     label: "Canal de Comunicación",filterable: true  },
    { key: "calificacion",     label: "Calificación",         filterable: true  },
    { key: "descripcion",      label: "Descripción",          filterable: true  },
    { key: "agent",            label: "Agente",              filterable: true  },
    { key: "estado",           label: "Estado",              filterable: true  },
    { key: "accion",           label: "Acción",              filterable: false },
  ];

 const formattedData = params.results.map((item, idx) => ({
    ...item,
    indice: idx + 1,
    // suponiendo que campaign y agent vienen como [ [nombre], ... ]
    campaign: item.campaign?.[0]?.[0] ?? "N/A",
    agent:    item.agent?.[0]?.[0]     ?? "N/A",
    accion: (
      <>
        {(item.estado === "FINALIZADO" || item.estado === "VENCIDO") && (
          <span
            className="fas fa-eye fa-lg me-2"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setDetallesModal(true);
              setGestionDetallada(item);
            }}
          />
        )}
        {item.estado === "EN_GESTION" && (
          <span
            className="fas fa-pen fa-lg"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setDetallesModal(true);
              setGestionDetallada(item);
            }}
          />
        )}
      </>
    ),
  }));
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title> Cuidad Limpia | Gestión del Contacto </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Col className="d-flex gap-3 mb-4 align-items-center">
            <ButtonVolver />
            <span style={{ fontSize: "1.2rem", fontWeight: "600" }}>
              Gestión del contacto
            </span>
          </Col>

          {detallesModal ? (
            <ModalManagementDetails
              isOpen={detallesModal}
              onCloseClick={handleDetallesModal}
              GestionDetallada={GestionDetallada}
            ></ModalManagementDetails>
          ) : null}

          {loading ? (
            <Loader />
          ) : (
            <div>
              <Card>
                <CardBody>
                  <Row className="d-flex justify-content-center">
                    <Col lg={12}>
                      <Row>
                        <Col>
                          <Flatpickr
                            className="form-control d-block"
                            placeholder="Fecha"
                            options={{
                              mode: "range",
                              dateFormat: "Y-m-d",
                              locale: "es",
                            }}
                            onChange={handleDateChange}
                            value={selectedDate}
                          />
                        </Col>
                        {groups.includes("SuperAdmin") ||
                        groups.includes("Administrador") ||
                        groups.includes("Supervisor") ? (
                          <>
                            <Col>
                              <Select
                                onChange={handleSelectEstadoChange}
                                options={[
                                  { value: "", label: "---------" },
                                  { value: "EN_GESTION", label: "En Gestión" },
                                  { value: "VENCIDO", label: "Vencido" },
                                  { value: "FINALIZADO", label: "Finalizado" },
                                  { value: "PENDIENTE", label: "Pendiente" },
                                ]}
                                placeholder="Estado"
                                value={selectedEstado}
                              />
                            </Col>
                            <Col>
                              <Select
                                className="me-1"
                                options={
                                  Array.isArray(agent)
                                    ? [
                                        { label: "Todos", value: "" },
                                        ...agent.map((item) => ({
                                          label: item.get_full_name,
                                          value: item.id,
                                        })),
                                      ]
                                    : []
                                }
                                value={selectedAgents}
                                onChange={handleSelectChange}
                                isMulti={true}
                                placeholder="Agentes"
                                menuPosition="fixed"
                              />
                            </Col>
                            <Col>
                              <Select
                                className=" me-1"
                                options={
                                  Array.isArray(campaignData)
                                    ? [
                                        { label: "----------", value: "" },
                                        ...campaignData.map((item) => ({
                                          label: item.name,
                                          value: item.id,
                                        })),
                                      ]
                                    : []
                                }
                                onChange={handleSelectCampaignChange}
                                value={selectedCampaign}
                                menuPosition="fixed"
                                placeholder="Campañas"
                              />
                            </Col>
                            <Col>
                              <Select
                                className="me-1"
                                options={[
                                  { value: "WhatsApp", label: "WhatsApp" },
                                  {
                                    value: "Telefonia - Manual",
                                    label: "Telefonía - Manual",
                                  },
                                ]}
                                onChange={handleSelectTypeChange}
                                value={selectedType}
                                menuPosition="fixed"
                                placeholder="Tipo"
                              />
                            </Col>
                            <Col>
                              <div className="form-check">
                                <Input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="isLeadCheck"
                                  checked={isLead}
                                  onChange={(e) => setIsLead(e.target.checked)}
                                />
                                <Label
                                  className="form-check-label"
                                  for="isLeadCheck"
                                >
                                  ¿Lead?
                                </Label>
                              </div>
                            </Col>
                            <Col lg={2}>
                              <Button
                                color="warning"
                                className="btn-sm me-1 mt-1"
                                onClick={filterDate}
                              >
                                <b>Consultar</b>
                              </Button>
                              <Button
                                color="danger"
                                className="btn-sm me-1 mt-1"
                                onClick={resetSearch}
                              >
                                <b>Borrar</b>
                              </Button>
                            </Col>
                          </>
                        ) : null}
                      </Row>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              <Card>
                {params.results ? (
                  <CardBody className="ps-5 pe-5">
                    <div className="d-flex justify-content-between align-items-center">
                      <h2 className="font-size-20">Historial</h2>
                      <button
                        className="btn btn-secondary  text-dark"
                        onClick={exportExcel}
                      >
                        <img
                          className="me-1"
                          alt=""
                          src={excelLogo}
                          height="20px"
                        />{" "}
                        <b>Exportar</b>
                      </button>
                    </div>
                    <p>
                      <b>Total de Gestiones: {params.count} </b>
                    </p>
                    <div className="table-responsive">
                      <Table
                        data={formattedData}
                        columns={columns}
                        theme={theme}
                        // no usamos onRowClick, gestionamos acciones en columna 'accion'
                      />
                    </div>
                    <Pagination
                      count={params.count}
                      next={params.next}
                      previous={params.previous}
                      limit={30}
                      filter={true}
                      contact={id}
                      baseUrl={`contact/gestionContacto/get_gestiones_contacto/`}
                      filterFunction={getFilterData}
                    />

                    <Row className="col-lg-12 justify-content-center">
                      <Col md={2}>
                        <Link
                          className="btn btn-secondary text-dark ms-5"
                          to={`/contacts/`}
                        >
                          Volver
                        </Link>
                      </Col>
                    </Row>
                  </CardBody>
                ) : (
                  <CardBody>
                    <h4 className="card-title">No se encontraron resultados</h4>
                  </CardBody>
                )}
              </Card>
            </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
}


const mapStateToProps = (state) => {
  const { error, loading, gestionesContacto } = state.GestionesContacto;
  return { error, loading, gestionesContacto };
};

export default withRouter(connect(mapStateToProps)(GestionContacto));
